// extracted by mini-css-extract-plugin
export default {"segment":"TransferenciasPage_segment__jgriI"};